import { Component, OnInit } from '@angular/core';
import { AppService } from '../../app.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-about-popup',
  templateUrl: './about-popup.component.html',
  styleUrls: ['./about-popup.component.scss']
})
export class AboutPopupComponent implements OnInit {
  SiteCode: number;
  ContactInfoEmail:string
  CurrentYear: number;
  version: string;
  constructor(private appService: AppService,
    public dialogRef: MatDialogRef<AboutPopupComponent>,
    ) { }

  ngOnInit() {
    this.appService.getSiteCode().subscribe(r => {
      this.SiteCode = r;
    });

    this.appService.getApplicationInfoEmail().subscribe(r => {
      this.ContactInfoEmail = r;
    });

    this.CurrentYear = new Date().getFullYear();
    this.getVersion();
  }
  getVersion(){
    this.appService.getVersion().subscribe(r => {
      console.log(r);
      this.version = r;
    });
  }
  onNoClick() {
    this.dialogRef.close();
  }
}
